export const SETTING = 'SETTING'
